import { render } from "./AdminCourses.vue?vue&type=template&id=d03d6940&scoped=true"
import script from "./AdminCourses.vue?vue&type=script&lang=js"
export * from "./AdminCourses.vue?vue&type=script&lang=js"

import "./AdminCourses.vue?vue&type=style&index=0&id=d03d6940&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d03d6940"]])

export default __exports__